const state = {
  mode: 'monthly',
  date: new Date(),
};

const getters = {
  currentPeriod: (state) => ({
    mode: state.mode,
    date: state.date,
  }),
};

const mutations = {
  SET_PERIOD(state, payload) {
    state.mode = payload.mode;
    state.date = payload.date;
  },
};

const actions = {
  updatePeriod({ commit }, payload) {
    commit('SET_PERIOD', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};